import React, {PropTypes} from 'react';
import ReactDOM from 'react-dom';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import theme from './theme';
import currencyFormatter from 'currency-formatter';
import Routes from './Routes.jsx';

import injectTapEventPlugin from 'react-tap-event-plugin';
// Needed for onTouchTap
// Check this repo:
// https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin();

const App = () => (
  <MuiThemeProvider muiTheme={getMuiTheme(theme)}>
    <Routes />
  </MuiThemeProvider>
);

App.getChildContext = function() {
  return {muiTheme: getMuiTheme(baseTheme)};
};

App.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

Date.prototype.vzla = function() {
        let day = this.getUTCDate() < 10 ? '0' + this.getUTCDate() : this.getUTCDate(),
            month = (this.getUTCMonth() + 1) < 10 ? '0' + (this.getUTCMonth() + 1) : this.getUTCMonth() + 1,
            year = this.getUTCFullYear();

        return day + '-' + month + '-' + year;
};

Date.prototype.usa = function() {
        let day = this.getUTCDate() < 10 ? '0' + this.getUTCDate() : this.getUTCDate(),
            month = (this.getUTCMonth() + 1) < 10 ? '0' + (this.getUTCMonth() + 1) : this.getUTCMonth() + 1,
            year = this.getUTCFullYear();

        return year + '-' + month + '-' + day;
};

Number.prototype.bs = function() {
  return currencyFormatter.format(this.valueOf(), { code: 'VEF' });
};

Number.prototype.fmtd = function() {
  return currencyFormatter.format(this.valueOf(), { decimal:',', thousand:'.' });
};

ReactDOM.render(
  <App />,
  document.getElementById('reactContainer')
);



/** WEBPACK FOOTER **
 ** ./app-react/main.jsx
 **/